
const observers: Function[] = [];

export function addKeyPressObserver(observer: Function) {
    observers.push(observer);
}
export function removeKeyPressObserver(observer: Function) {
    const obs = observers.indexOf(observer);
    if (obs > -1) {
        observers.splice(obs, 1);
    }
    //filterInPlace(observers, (obs) => {
    //  console.log("remove", obs === observer);
    //  return obs === observer;
    //});
}
export function handleKeyPress(key: KeyboardEvent) {
    const k = key.key.toLowerCase();
    if (
        k.match(
            /^([a-zåäö]|arrowup|arrowdown|arrowleft|arrowright|\s|backspace|enter)$/
        ) && (!key?.ctrlKey)
    ) {
        observers.forEach((notify: Function) => {
            notify(k);
        });
    } else console.log("NO");
}